import React from "react";
import "./Help.css";

export const Help = () => {

    return (
        <div className="help main-content p-20" style={{overflow: 'auto'}}>
             <div className="title2">
                IMPORTANT NOTE:
            </div>
            <div className="bold red">
                Your DPC-5 Gen3 must be updated to firmware v1.05h in order to use this editor.
            </div>
            <div className="mt-10 line-125">
                Latest firmware, update tools, and info are available on our <a href="https://www.disasterareadesigns.com/support">support page</a>.
            </div>
            <div className="title2">
                How to connect your DPC-5 Gen3:
            </div>
            <div className="bold red">
                Requires USB mode set to MIDI.
            </div>
            <div className="mt-10">
                If you are using USB HOST mode on your controller:
            </div>
            <ol>
                <li>Plug in a USB cable.</li>
                <li>Wait 1 second.</li>
                <li>Hold the A and B footswitches to enter SETUP.</li>
                <li>Navigate to USB, set to MIDI and hold the SAVE button (far left) to save and exit.</li>
                <li>Restart the controller after saving to reset the USB port.</li>
            </ol>
            <div className="title2">
                How to use the editor:
            </div>
            <div className="mt-10 line-125">
                After connecting your device, give the app a few seconds to recognize the device and read its configuration.
            </div>
            <div className="mt-20 line-125">
                If the editor display the version of your device, everything's ok and you can proceed with the configuration.<br />
            </div>
            <div className="mt-5">
                Otherwise :
            </div>
            <ol>
                <li>refresh the editor window in your browser with Cmd-R (Mac) or F5 (Windows.)</li>
                <li>check the MIDI input and MIDI output selection.</li>
                <li>check the USB mode of the DPC-5 (see above.)</li>
                <li>ensure your device is running v1.05 or higher firmware, the version number scrolls the display at boot.</li>
                <li>check your cable.</li>
            </ol>
            <div className="mt-20 line-125">
                Each time you modify a parameter, a yellow background will appear to show that the parameter's value has been edited.
                After a few seconds, the new value will be saved in the DPC-5 and the yellow background will disappear.
            </div>
            <div className="mt-5 line-125">
                If a yellow background persists after you have changed a parameter, that means that the editor is unable to write the new value in the DPC-5.
                In that case please check the MIDI input/output selection, the cable, the USB mode (see above).
            </div>
            <div className="mt-5 line-125">
                Note: you can use the editor without a controller connected. In that case, after you have set up your configuration and your presets, use
                the Export feature to save your configuration in a file. You can re-import this file later on to update your device.
            </div>
            <div className="title2">
                Latest BETA firmware:
            </div>
            <div className="mt-10 line-125">
                Download <a href="../files/dpc5_beta.bin">here</a>.
            </div>
            <div>
                Update tools and info are available on our <a href="https://www.disasterareadesigns.com/support">support page</a>.
            </div>
           <div className="title2">
                Need help?  Have feedback about the editor?
            </div>
            <div className="mt-10 line-125">
                Please contact us using the <a href="https://www.disasterareadesigns.com/support">support page</a>.
            </div>
             <div className="title2">
                Editor Changelog
            </div>
            <div className="mt-10 line-125">
                * 0.10.14 fix issue with jack and exp channels, add Volante device
            </div>
            <div className="mt-10 line-125">
                * 0.10.13 Add dark mode (experimental!) change MIDI activity indicators to preserve layout
            </div>
            <div className="mt-10 line-125">
                * 0.10.12 Fix autoconnect issue, add new devices
            </div>
            <div className="mt-10 line-125">
                * 0.10.11 Added check for device type, added header image
            </div>
            <div className="mt-10 line-125">
                * 0.10.10 Fix issue with Web MIDI error message, now hides unused bank names
            </div>
            <div className="mt-10 line-125">
                * 0.10.8 Add HX One, Chroma Console, fix issue with preset name display, requires 1.05e FW
            </div>
            <div className="mt-10 line-125">
                * 0.10.7 Fix issue with preset channel not changing correctly, requires 1.05d FW
            </div>
            <div className="mt-10 line-125">
                * 0.10.6 DPC allow FAVE preset to always be displayed for editing, requires 1.05c FW
            </div>
            <div className="mt-10 line-125">
                * Fixed bank names not showing for SCROLL and SCROLL4 bank name modes
            </div>
            <div className="mt-10 line-125">
                * 0.10.5 DPC added bank name edit on Config page, will move later, requires 1.05c FW
            </div>
            <div className="mt-10 line-125">
                * 0.10.4 DPC fixed issues with FAVE preset loading, fixed loading "D" presets if not enabled
            </div>
            <div className="mt-10 line-125">
                * 0.10.3 DPC Added support for Wampler Pantheon
            </div>
            <div className="mt-10 line-125">
                * 0.10.2 DPC added support for Walrus R1 / M1, fixed showing correct number of banks
            </div>

        </div>
    );
}
